module.exports = __webpack_public_path__ + "img/LimitBee-1.a893dfbd.png";